import { HotjarIdentifier, HotjarTag } from './types';

export const startHotjarRecording = (identifier: HotjarIdentifier) => {
  if (window.top!.hj) {
    window.top!.hj('trigger', identifier);
  }
};

export const tagRecording = (tag: HotjarTag) => {
  if (window.top!.hj) {
    window.top!.hj('tagRecording', [tag]);
  }
};
